import { colors, colorsCSS } from "./colors";
import { fontSizes } from "./fonts";
import { theme } from "./theme";

export { colors, colorsCSS, fontSizes, theme };
